import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { initialUser } from "../../const";
import { validateEmail } from "../../../../../utils/validateEmail";

export const useRegister = () => {
  const [user, setUser] = useState(initialUser);
  const [loading, setloading] = useState(false);
  const [error, seterror] = useState({});
  const [success, setsuccess] = useState();
  const [isValidEmail, setIsValidEmail] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const isUserFilled = Object.values(user).every((v) => v.trim() !== "");
    if (isUserFilled) {
      const isValid = validateEmail(user.email);
      if (isValid) {
        seterror({});
        setIsValidEmail(true);
      } else {
        setIsValidEmail(false);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  async function register() {
    const { password, cpassword } = user;
    if (password === cpassword) {
      try {
        setloading(true);
        await axios.post("/api/users/register", user);
        setloading(false);
        setsuccess(true);
        setUser(initialUser);
        navigate("/login");
      } catch (error) {
        console.log(error);
        setloading(false);
        seterror(error.response.data.message);
      }
    } else {
      Swal.fire("Error!", "Password not matched", "error");
    }
  }

  return {
    isValidEmail,
    user,
    setUser,
    loading,
    error,
    success,
    register,
  };
};
